import React, { useState } from "react";
import clsx from "clsx";
import { Col, Row } from "react-bootstrap";

import { TablePagination, Skeleton } from "components";

import { EditableTableRow } from "./rows/editableTableRow";
import { TableRow } from "./rows/tableRow";

import styles from "./tables.module.scss";

/**
 * @deprecated Use Table component instead
 *
 * Old comments:
 *
 * (1)	=> headers is array of strings.
 * (2)	=> row: { id, columns: [], edit }. Internaly adds edit: boolean to row.
 * (3)	=> column: { id, type, name, value }.
 * => type - "date"/"currency".
 * (4)	=> columnsStructure is used for creation to map element to proper object.
 */
export const EditableTable = ({
	headers = [],
	rows = [],
	columnsStructure = [],
	count,
	page,

	// Actions
	onAdd,
	onEdit,
	onDelete,
	handlePageChange,

	// Styles
	className,
	headerClassName,
	bodyClassName,
	actionsClassName,
	inputFieldColSize = 12,

	// Customization
	useFirstRowForAddition = false,
	isEditable = true,
	showEmptyBlock = false,
	hideFooter = true,

	loading,
	dateFormat,
}) => {
	const [editState, setEditState] = useState({});

	const handleEditRowToggle = async (rowIndex, formValues) => {
		if (onEdit && formValues) {
			// Changnig from Edit State to View State
			await onEdit(rowIndex, formValues); // means that Row was edited and should be saved
		}
		toggleEditRow(rowIndex);
	};

	const toggleEditRow = rowIndex => {
		setEditState({
			...editState,
			[rows[rowIndex].id]: !editState[rows[rowIndex].id],
		});
	};

	const handleHideEditRow = () => {
		setEditState({});
	};

	const Loader = ({ skeleton, component }) => {
		return loading ? skeleton() : component();
	};

	return (
		<div className={clsx(className, styles.table)}>
			<Row className={clsx(headerClassName, styles.header)}>
				{headers.map((title, i) => (
					<Col key={`${title}-${i}`}>
						<span>{title}</span>
					</Col>
				))}
			</Row>
			<div className={clsx(bodyClassName, styles.body)}>
				{useFirstRowForAddition && (
					<EditableTableRow
						key="add-table-row"
						loading={loading}
						dateFormat={dateFormat}
						row={{ columns: columnsStructure }}
						onDeleteClick={() => {}}
						onSaveClick={onAdd}
						actionsClassName={actionsClassName}
						inputFieldColSize={inputFieldColSize}
					/>
				)}
				{rows.length === 0 && showEmptyBlock ? (
					<div className={styles.emptyText}>
						No Records to Display
					</div>
				) : (
					rows.map((row, i) =>
						editState[row.id] ? (
							<EditableTableRow
								key={`table-row-${row.id}`}
								row={row}
								dateFormat={dateFormat}
								onSaveClick={formValues =>
									handleEditRowToggle(i, formValues)
								}
								onHideEditRowClick={handleHideEditRow}
								actionsClassName={actionsClassName}
								inputFieldColSize={inputFieldColSize}
								loading={loading}
							/>
						) : (
							<TableRow
								key={`table-row-${row.id}`}
								onEditClick={() => toggleEditRow(i)}
								onDeleteClick={
									onDelete && (() => onDelete(i, row.id))
								}
								columns={row.columns}
								actionsClassName={actionsClassName}
								isEditable={isEditable}
								loading={loading}
							/>
						),
					)
				)}
				<Loader
					skeleton={() => <Skeleton height="51px" marginTop="5px" />}
					component={() => {
						return (
							<>
								{!hideFooter && rows.length !== 0 && (
									<TablePagination
										page={page}
										count={count}
										handlePageChange={handlePageChange}
									/>
								)}
							</>
						);
					}}
				/>
			</div>
		</div>
	);
};
